//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 右侧栏bar right bar
 * @author walker
 */
// import Vue from "vue";

export default {
  name: "RightBar",
  componentName: "RightBar",
  props: {
    items: {
      type: Array,
      default: () => {
        return ["community", "support", "rocket"];
      },
    },
    communityText: {
      type: String,
      default: "Community",
    },
    supportText: {
      type: String,
      default: "Support",
    },
    rocketText: {
      type: String,
      default: "Back to top",
    },
  },
  data() {
    return {
      isShow: false,
      right: 0,
      showMap: {
        facebook: false,
        twitter: false,
        news: false,
        faq: false,
        community: false,
        support: false,
        share: false,
        review: false,
        rocket: true,
      },
    };
  },
  created: function () {},
  mounted: function () {
    this.initState();
    this.initEvent();
  },
  methods: {
    initEvent: function () {
      document.addEventListener("scroll", this.onScroll);
    },
    initState: function () {
      for (let i = 0; i < this.items.length; i++) {
        if (Object.prototype.hasOwnProperty.call(this.showMap, this.items[i])) {
          this.showMap[this.items[i]] = true;
        }
      }
    },
    onScroll: function () {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 768) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // onSupportClick: function () {
    //   import("@/components/support").then((component) => {
    //     Vue.use(component.default, this);
    //     this.$support();
    //   });
    // },
  },
};
